<div *ngIf="view == true" [ngClass]="!viewCarousel ? 'container' : ''">

  <app-carousel *ngIf="viewCarousel; else standaloneDescriptionView">

    <ng-template carouselItem="1">
      <ng-container *ngTemplateOutlet="matDescriptionContentTemplate"></ng-container>
    </ng-template>

    <ng-template carouselItem="2">
      <mat-card style="height: 70vh" class="mat-card-c">
        <h2 style="display: flex; justify-content: center">
          <strong>Recursos</strong>
        </h2>
        <app-button-label [labelsEdit]="labels"></app-button-label>
        <data-table
          [title]="''"
          [columns]="columnsResouces"
          [configuration]="configurationResouces"
          [url]="urlGetTablaResourcesRequest"
          [params]="paramsResourcesRequest"
          (internalData)="dataResources($event)"
        >
        </data-table>
      </mat-card>
    </ng-template>
  </app-carousel>

  <ng-template #standaloneDescriptionView>
    <ng-container *ngTemplateOutlet="matDescriptionContentTemplate"></ng-container>
  </ng-template>

</div>

<ng-container *ngIf="!viewCarousel; else buttonsTemplateRef"> </ng-container>
<div *ngIf="view == false && action == 'editar'">
  <mat-tab-group>
    <mat-tab label="Solicitud de Mantenimiento">
      <form
        [formGroup]="formEdit"
        (ngSubmit)="formEdit.valid ? finalizar(formEdit.value) : errorMessage()"
      >
        <div style="width: 100%; display: flex; margin: 30px 0 0 0">
          <div style="flex: 8; margin: 0 15px 0 0">
            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  matInput
                  formControlName="description"
                  placeholder="Descripción"
                  #descripcion
                  maxlength="255"
                />
                <mat-hint>{{ descripcion.value?.length || 0 }}/255</mat-hint>
              </mat-form-field>
            </div>
            <div class="row-item">
              <combos
                [dataCombos]="typeOfMaintenance"
                [configuration]="combosTypeOfMaintenance"
                [required]="true"
                [reloadCombo]="reloadComboTypeOfMaintenance"
                (changeOption)="changesTypeOfMaintenance($event)"
              >
              </combos>
            </div>
            <div class="row-item">
              <mat-form-field>
                <mat-label>Fecha ejecución</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickerCompra"
                  autocomplete="off"
                  formControlName="executionDate"
                  required
                />
                <mat-datepicker-toggle matSuffix [for]="pickerCompra">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerCompra
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="row-item" *ngIf="!inventoryModule">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  formControlName="resources"
                  matInput
                  #recursos
                  maxlength="255"
                  placeholder="Recursos"
                />
                <mat-hint>{{ recursos.value?.length || 0 }}/255</mat-hint>
              </mat-form-field>
            </div>
          </div>
          <div style="flex: 0.2">
            <button mat-mini-fab color="warn" type="submit" [disabled]="formEdit.invalid">
              <mat-icon>save</mat-icon>
            </button>
            <button
              mat-mini-fab
              color="primary"
              (click)="back()"
              style="margin-top: 10px"
              type="button"
            >
              <mat-icon>reply</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </mat-tab>
    <mat-tab label="Recursos" *ngIf="inventoryModule && resources?.length > 0">
      <div style="margin: 30px">
        <data-table
          [columns]="columnsResouces"
          [configuration]="configurationResoucesEdit"
          [reloadTable]="reloadResoucesRequest"
          [url]="urlGetTablaResourcesRequest"
          [params]="paramsResourcesRequestEdit"
          (delete)="deleteResources($event)"
          (add)="addResources($event)"
          (edit)="editResources($event)"
          (internalData)="getResourceByRequestTable($event)"
        >
        </data-table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #matDescriptionContentTemplate>
  <div *ngIf="view == true">
    <mat-card
      class="mat-card-c"
      [style]="viewCarousel ? 'height: 70vh' : ''"
    >
      <div class="d-flex justify-content-end">
        <div>
          <h4
            *ngIf="bodyActividad.created"
            class="m-0 p-0 text-center font-weight-bold"
            [style]="movil ? 'font-size: x-small; line-height: 0.6;' : ''"
          >
            Creación Solicitud
          </h4>
          <h3
            class="m-0 p-0 text-center"
            [style]="movil ? 'font-size: x-small;' : ''"
          >
            {{ bodyActividad.created | dateFormat }}
          </h3>
        </div>
      </div>
      <h2 style="display: flex; justify-content: center">
        <strong>Solicitud de Mantenimiento</strong>
      </h2>
      <h3>Equipo: {{ bodyActividad.code }}</h3>
      <h3>Descripción: {{ bodyActividad.description }}</h3>
      <h3>Realización mantenimiento: {{ bodyActividad.date }}</h3>
      <h3>Tipo Mantenimiento: {{ bodyActividad.maintenanceType }}</h3>
      <h3>Solicita: {{ bodyActividad.requestName }}</h3>
      <h3 *ngIf="!inventoryModule">Recursos: {{ bodyActividad.resources }}</h3>
      <h3
        *ngIf="
          rol == 'Administrativo' ||
          rol == 'root' ||
          rol == 'Jefe Mantenimiento'
        "
      >
        Costo Mantenimiento: {{ bodyActividad.cost | number : "1.0-0" }}
      </h3>
      <h3
        *ngIf="
          (rol == 'Administrativo' ||
            rol == 'root' ||
            rol == 'Jefe Mantenimiento') &&
          inventoryModule
        "
      >
        Costo Recursos: {{ totalCostItems | number : "1.0-0" }}
      </h3>
      <mat-card-footer *ngIf="viewCarousel; else buttonsTemplateRef"> </mat-card-footer>
    </mat-card>
  </div>
</ng-template>

<ng-template #buttonsTemplateRef>
  <div
    *ngIf="
      rol == 'Administrativo' || rol == 'root' || rol == 'Jefe Mantenimiento'
    "
    style="justify-content: space-between"
    class="button"
  >
    <button
      style="width: 45%"
      color="warn"
      class="button-save mat-elevation-z5"
      mat-raised-button
      (click)="response('rechazar')"
    >
      Rechazar
    </button>
    <button
      style="width: 45%"
      color="primary"
      class="button-save mat-elevation-z5"
      mat-raised-button
      (click)="response('autorizar')"
    >
      Autorizar
    </button>
  </div>

  <div
    *ngIf="rol == 'Operario' && view == true" 
    style="justify-content: center"
    class="button"
  >
    <button
      style="width: 60%"
      color="primary"
      class="button-save mat-elevation-z5"
      mat-raised-button
      (click)="edit('editar')"
    >
      Editar
    </button>
  </div>
</ng-template>